import { Box } from '@mantine/core'

import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs'
import { CollectionFilters } from 'src/components/Collection/CollectionFilters'
import { CollectionLinks } from 'src/components/Collection/CollectionLinks'
import styles from 'src/components/CollectionHeadline/CollectionHeadline.module.scss'
import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { useLocale } from 'src/contexts/LocaleContext'
import { generateBreadcrumbs } from 'src/functions/util/generateBreadcrumbs'
import { getMetafield } from 'src/functions/util/getMetafield'

import type { Collection } from 'src/data/graphql-generated'
import type { CollectionBreadcrumb } from 'src/types/Collection'

interface CollectionHeadlineProps {
  collection: Collection
  breadcrumbs: CollectionBreadcrumb[]
  coffeeSubcollections: Collection[]
  filtersMeta: {
    filters: string[]
    activeFilter: string | ''
    setActiveFilter: (s: string) => void
  }
}

export const CollectionHeadline = ({
  breadcrumbs,
  collection,
  coffeeSubcollections,
  filtersMeta,
}: CollectionHeadlineProps) => {
  const { language } = useLocale()

  const { title, descriptionHtml, metafields } = collection
  const { filters, activeFilter, setActiveFilter } = filtersMeta

  const pageTitle: string = getMetafield(metafields, 'collection', 'title') || title
  const generatedBreadcrumbs = generateBreadcrumbs(breadcrumbs, language)

  return (
    <Container className={styles.container}>
      <Box mb={{ base: 'xs', md: 'md' }}>
        <Breadcrumbs items={generatedBreadcrumbs} />
      </Box>
      <Box mb={{ base: 'xs', md: 'md' }}>
        <Headline variant="h1">{pageTitle}</Headline>
      </Box>
      <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} suppressHydrationWarning />
      {!!coffeeSubcollections.length && <CollectionLinks subcollections={coffeeSubcollections} />}
      {filters.length > 0 && (
        <CollectionFilters filters={filters} activeFilter={activeFilter} onSelect={setActiveFilter} />
      )}
    </Container>
  )
}
